import { app } from '../../app.module'
/**
 * 順位を選択するフォーム。順位を選択した場合、イベントを送信する
 * attribute: {number} range 選択可能な順位の範囲
 */
class RankFormComponentCtrl {
  private scope: ng.IScope
  private label: string
  private ranks: (string | number)[]
  private range: number
  private initFlg: boolean

  constructor($scope) {
    this.scope = $scope
    this.label = '順位'
    this.initFlg = true
  }

  /**
   * 初期化
   */
  public $onInit(): void {
    this.ranks = this.makeRanks()
  }

  /**
   * 選択した順位をイベント送信する
   * @param {string} selectedRank
   */
  public selectRank(selectedRank: string) {
    if (selectedRank === '指定しない') {
      selectedRank = null
    }

    // イベントをemitする
    this.scope.$emit('changeFilterData', {
      type: 'rank',
      value: selectedRank,
    })
  }
  /**
   * 選択する順位を作成する
   * @return {Array} 選択可能な順位の一覧
   */
  private makeRanks() {
    const ranks: (string | number)[] = []
    ranks.push('指定しない')
    for (let i = 1; i <= this.range; i = i + 1) {
      ranks.push(i)
    }
    return ranks
  }
}

app.component('rankForm', {
  template: require('./rank-form.pug')(),
  bindings: {
    range: '@',
  },
  controller: RankFormComponentCtrl,
})
